module.exports = __webpack_public_path__ + "img/Sachdev.67371f48.jpg";